// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"RightPanel_btnContainer__313rV","sectionTitle":"RightPanel_sectionTitle__2JbOg"};